import { render, staticRenderFns } from "./table-extension-design.vue?vue&type=template&id=2b7e726b&"
import script from "./table-extension-design.vue?vue&type=script&lang=js&"
export * from "./table-extension-design.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports